import { FuseRouteConfigType } from '@fuse/utils/FuseUtils';
import authRoles from '../authRoles';
import UpdatePetProfileApp from '../../client/addpet/components/UpdatePetProfile/UpdatePetProfileApp';

const RecoverStartConfig: FuseRouteConfigType = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: 'recover/start',
			element: <UpdatePetProfileApp />
		}
	]
};

export default RecoverStartConfig;
